module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "enterprise"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Entreprise",
      "identifier": "enterprise"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Entreprise</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over din entreprise-forretning\n            ")])]), _vm._v(" "), _c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('main-project-types', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'mainProjectTypes'),
      expression: "selectedItem === 'mainProjectTypes'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('mainProjectTypes', $event)
      }
    }
  }), _vm._v(" "), _c('main-projects', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'mainProjects'),
      expression: "selectedItem === 'mainProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('mainProjects', $event)
      }
    }
  }), _vm._v(" "), _c('employees-sub-projects', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'employeesSubProjects'),
      expression: "selectedItem === 'employeesSubProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('employeesSubProjects', $event)
      }
    }
  }), _vm._v(" "), _c('sub-project-types', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'subProjectTypes'),
      expression: "selectedItem === 'subProjectTypes'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('subProjectTypes', $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d9a7c39"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/enterprise/index.vue
// module id = 834
// module chunks = 0